import { DropdownMenu, FormField } from 'taboola-ultimate-ui';
import { withIndication } from 'modules/errors/components';
import { useCriteria } from 'modules/push-api/hooks/useCriteria';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './criteriaDropdown.module.scss';

const FormFieldWithIndication = withIndication(FormField);
const formFieldId = 'criteria-selector';

export const CriteriaDropdown = ({ selectedCriteria }) => {
    const options = useCriteria();

    return (
        <FormFieldWithIndication
            inputId={formFieldId}
            containerClass={styles['field-container']}
            label={<FormattedMessage id="push.api.create.settings.criteria.label" defaultMessage="Criteria" />}
            labelClass={styles['label']}
        >
            <div className={styles['field']}>
                <DropdownMenu
                    id={formFieldId}
                    selectedValueObject={{
                        value: selectedCriteria,
                    }}
                    options={options}
                    onChange={() => {}}
                    disabled={true}
                    searchable
                    aria-label="criteria-dropdown"
                    className={styles['dropdown-menu']}
                />
            </div>
        </FormFieldWithIndication>
    );
};
